import React from 'react'
import { ContentHeader } from '../../../../../layout/Content'

function ProductsSoldHeader() { return ( <ContentHeader title='Products Sold Report' /> ) }

export default React.memo(ProductsSoldHeader)
